import React, { useEffect } from "react";
import { Box, ListItemText } from "@mui/material";
import { Link } from "react-router-dom";
import SidebarDrawerFooter from "../../../../_default/SidebarDrawerFooter";
import { useTheme } from "@mui/material/styles";
import { useLayout } from "../../../../_context/DefaultProvider";
import useSmoothResponsiveFontSize from "../../../../../_hook/useSmoothResponsiveFontSize";
import { StyledIcon, StyledListItemButton } from "./MenuList";
const LeftNavFooter = (props) => {
  const theme = useTheme(); // To get the theme palette
  const { drawerStates } = useLayout();
  const customfontsize = useSmoothResponsiveFontSize({});

  useEffect(() => {}, [customfontsize]);
  return (
    <SidebarDrawerFooter {...props}>
      {({ currentWidth }) => (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: !drawerStates?.isExpanded ? "center" : "start",
          }}
        >
          <StyledListItemButton
            component={Link}
            to={"/setting"}
            isanimated={false}
            istop={false}
            customfontsize={customfontsize}
          >
            <StyledIcon
              style={{
                color: theme.palette.white.main,

                fontSize: drawerStates?.isExpanded
                  ? `${2 * customfontsize}px`
                  : `${3 * customfontsize}px`,
              }}
            >
              settings
            </StyledIcon>

            {drawerStates?.isExpanded && (
              <ListItemText
                primary={"Setting"}
                sx={{
                  paddingLeft: ".5rem",
                  textWrap: "nowrap",
                  fontSize: `${customfontsize}px`,
                  color: theme.palette.white.main,
                }}
              />
            )}
          </StyledListItemButton>
        </Box>
      )}
    </SidebarDrawerFooter>
  );
};

export default LeftNavFooter;
